import React, { useMemo } from 'react';
import { getGiBfromMiBOneDecimal, getStatusBarColor } from '../../../../../../../lib/helpers';
import { Progress, Typography } from '../../../../../../../components';
import { HomeOutlined, MenuOutlined } from '@ant-design/icons';

import './SingleDiskInfo.scss';

const { Text } = Typography;

export const SingleDiskInfo = ({ index, record }) => {
    const freeDiskSpace = record.storage_disks[index] - record.storage_disks_used[index];

    const percent = useMemo(() => {
        return (record.storage_disks_used[index] / record.storage_disks[index]) * 100 || 0;
    }, [record.storage_disks_used, record.storage_disks]);

    return (
        <div key={index} className="single-disk-info">
            <div className="single-disk-label-row">
                <Text className="disk-label">
                    <span>{index === 0 ? <HomeOutlined /> : <MenuOutlined />} Size:</span>{' '}
                    {`${getGiBfromMiBOneDecimal(record.storage_disks[index])} GiB` || 'N/A'}, Free:{' '}
                    {`${getGiBfromMiBOneDecimal(freeDiskSpace)} GiB` || 'N/A'}
                </Text>
            </div>
            <Progress
                percent={percent}
                showInfo={false}
                strokeColor={getStatusBarColor(record.storage_utilization[index])}
            />
        </div>
    );
};
